module.exports = __webpack_public_path__ + "static/media/fruit_boxes.9da6b2ba.jpeg";